<template>
	<div class="listing-analysis-page">
		<app-page>
			<app-heading :title="`${listing.title || listing.mls} Analysis`" />
			<!-- Annual Forecast -->
			<app-section>
				<div class="title">Annual Forecast</div>
				<app-row class="mt-2 metrics">
					<app-cell class="metric" self-align="center">
						<div class="metric-title font-weight-bold">
							Score
						</div>
						<div class="metric-value primary--text">
							<span v-if="init">
								{{ analysis.score.toFixed(1) }}
							</span>
							<span v-else>
								N/A
							</span>
						</div>
					</app-cell>
					<app-cell class="metric">
						<div class="metric-title font-weight-bold">
							Revenue
						</div>
						<div class="metric-value-with-details primary--text">
							<span v-if="init">
								${{ analysis.revenue.toFixed(2) }}
							</span>
							<span v-else>
								N/A
							</span>
						</div>
						<app-row v-if="init" class="metric-details">
							<app-cell cols="6">
								<div class="font-weight-bold">
									Low
								</div>
								<div class="error--text">
									${{ analysis.revenueLow.toFixed(2) }}
								</div>
							</app-cell>
							<app-cell cols="6">
								<div class="font-weight-bold">
									High
								</div>
								<div class="success--text">
									<span v-if="init">
										${{ analysis.revenueHigh.toFixed(2) }}
									</span>
								</div>
							</app-cell>
						</app-row>
					</app-cell>
					<app-cell class="metric">
						<div class="metric-title font-weight-bold">
							Occupancy Rate
						</div>
						<div class="metric-value primary--text">
							<span v-if="init">
								{{ analysis.occupancyRate.toFixed(2) }}% ({{analysis.nights}})
							</span>
							<span v-else>
								N/A
							</span>
						</div>
					</app-cell>
					<app-cell class="metric">
						<div class="metric-title font-weight-bold">
							ADR
						</div>
						<div class="metric-value primary--text">
							<span v-if="init">
								${{ analysis.adr.toFixed(2) }}
							</span>
							<span v-else>
								N/A
							</span>
						</div>
					</app-cell>
				</app-row>
			</app-section>

			<!-- Monthly revenue forecast -->
			<div v-if="init">
				<app-section class="mt-4">
					<div class="title">
						Revenue Forecast
					</div>
					<chart-line
						:colors="['green']"
						:labels="monthlyRevenue.labels"
						:value="monthlyRevenue.value"
						:headings="['Revenue']"
					/>
				</app-section>
				<app-section class="mt-4">
					<div class="title">
						Occupancy Forecast
					</div>
					<chart-line
						:colors="['purple']"
						:labels="monthlyNights.labels"
						:value="monthlyNights.value"
						:headings="['Nights']"
					/>
				</app-section>
				<app-section class="mt-4">
					<div class="title">
						ADR Forecast
					</div>
					<chart-line
						:colors="['blue']"
						:labels="monthlyADR.labels"
						:value="monthlyADR.value"
						:headings="['ADR']"
					/>
				</app-section>
			</div>
		</app-page>
	</div>
</template>

<script>
export default {
	data() {
		return {
			listing: {
				title: '',
				mls: '',
			},
			init: false,
			analysis: {
				score: 0,
				revenue: 0,
				revenueHigh: 0,
				revenueLow: 0,
				monthly: [],
				occupancyRate: 0,
				nights: 0,
				adr: 0,
			},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.listing
		},
		monthlyRevenue() {
			return this.analysis.monthly.reduce((acc, entry) => {
				acc.labels.push(entry.month)
				acc.value[0].push(Math.round(entry.revenue))
				return acc
			}, { labels: [], value: [[]] })
		},
		monthlyNights() {
			return this.analysis.monthly.reduce((acc, entry) => {
				acc.labels.push(entry.month)
				acc.value[0].push(entry.nights)
				return acc
			}, { labels: [], value: [[]] })
		},
		monthlyADR() {
			return this.analysis.monthly.reduce((acc, entry) => {
				acc.labels.push(entry.month)
				acc.value[0].push(Math.round(entry.adr))
				return acc
			}, { labels: [], value: [[]] })
		},
	},
	async mounted() {
		try {
			const [listing, analysis] = await Promise.all([
				this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('listings')
					.to(this.id)
					.get(),
				this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('listings')
					.to(this.id)
					.to('analysis')
					.get(),
			])

			this.listing = listing
			this.analysis = analysis
			this.init = true
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
}
</script>

<style scoped>
	.metric {
		background: #f3f3f3;
		text-align: center;
		margin: 10px 20px;
		font-size: 18px;
	}

	.metric-value {
		font-size: 28px;
	}

	.metric-value-with-details {
		font-size: 22px;
	}

	.metric-title, .metric-value {
		line-height: 40px;
	}

	.metric-details {
		font-size: 14px;
	}
</style>
